import * as yup from 'yup';
import { Maybe } from 'yup';
import { dateValidator, maxFileSizeValidator } from '@/utils/validators';
import { FileType } from '@/types';

yup.setLocale({
  mixed: {
    required: ({ path }) => `${path}は必須項目です`
  },
  string: {
    email: ({ path }) => `${path}が正しくありません`,
    max: ({ path, max }) => `${path}は${max}文字以内で入力してください`
  }
});

// 労務HRのvalidators.js email関数の正規表現で上書き。yup標準のemailルールより緩い。
yup.addMethod(yup.string, 'email', function validateEmail(message = yup.defaultLocale.string?.email) {
  return this.matches(/^([^@\s]+)@((?:[a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,})$/i, {
    message,
    name: 'email',
    excludeEmptyString: true
  });
});

yup.addMethod<yup.StringSchema>(yup.string, 'dateFormat', function dateFormat() {
  return this.test(
    'dateFormat',
    ({ label }) => `${label}の入力形式が正しくありません`,
    (value?: string) => {
      if (!value) return true;
      return dateValidator(value);
    }
  );
});

const MAX_FILE_SIZE = 1024 * 1024 * 10;

yup.addMethod<yup.MixedSchema>(yup.mixed, 'fileSize', function fileSize() {
  return this.file().test(
    'fileSize',
    ({ label }) => `${label}にアップロードできるファイル容量は10MB迄です。ご確認の上、再度アップロードください。`,
    (value?: FileType | File) => {
      if (!value) return true;
      if (!(value instanceof File)) return true;

      return maxFileSizeValidator(value, MAX_FILE_SIZE);
    }
  );
});

yup.addMethod<yup.MixedSchema>(yup.mixed, 'file', function file() {
  return this.meta({ file: true });
});

declare module 'yup' {
  interface StringSchema<TType extends Maybe<string> = string | undefined> {
    dateFormat(): StringSchema<TType>;
  }
  interface MixedSchema {
    fileSize(): this;
    file(): this;
  }
}

export { yup };
